export default __webpack_public_path__ + "static/media/26.e927cea0.mp3";